<template>
  <div class="form-section">
    <div class="d-flex mb-large" style="align-items: center">
      <div style="flex: 1"></div>
      <b-button class="ml-large" variant="outline-primary" size="sm" @click="openEnvCreator">
        <i class="fas fa-plus-circle"></i> new environment
      </b-button>
    </div>

    <b-table :items="environments" :fields="tableFields">
      <template #cell(actions)="row">
        <b-button class="btn-small mr-standard" variant="secondary" title="Edit" @click="openEnvEditor(row.item)">
          <i class="fas fa-pen"></i>
        </b-button>
      </template>
    </b-table>

    <modal-proxy-env-editor ref="modalProxyEnvEditorRef" :on-success="fetchAllEnvs"></modal-proxy-env-editor>
  </div>
</template>
<script>
  import ModalProxyEnvEditor from "./ModalProxyEnvEditor";
  import axios from 'axios';

  export default {
    components: {ModalProxyEnvEditor},
    data() {
      return {
        environments: [],
        tableFields: [
          {key: 'code', label: 'Code'},
          {key: 'url', label: 'Base URL'},
          {key: 'port', label: 'Port'},
          {key: 'forwardTestToken', label: 'Forward token'},
          {key: 'actions', label: 'Actions'}
        ]
      };
    },
    created() {
      this.fetchAllEnvs();
    },
    methods: {
      fetchAllEnvs() {
        axios.get(`/api/mockConfig/proxyEnvironment`)
          .then(response => {
            this.environments = response.data
          })
          .catch(e => {
            this.$onError(e);
          })
      },
      openEnvCreator() {
        this.$refs.modalProxyEnvEditorRef.showModal();
      },
      openEnvEditor(env) {
        this.$refs.modalProxyEnvEditorRef.showModal(env.code);
      }
    }
  };
</script>
